import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import t from 'format-message';
import { Link } from '@instructure/ui-link';
import { CloseButton } from '@instructure/ui-buttons';
import { View } from '@instructure/ui-view';
import { Flex } from '@instructure/ui-flex';
import { Text } from '@instructure/ui-text';
import { Popover } from '@instructure/ui-popover';
import { TruncateText } from '@instructure/ui-truncate-text';
import { Avatar } from '@instructure/ui-avatar';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Spinner } from '@instructure/ui-spinner';
import { useGradebookConfig } from "../../context/GradebookConfigContext/index.js";
import MasteryLevelIcon from "../../icons/MasteryLevelIcon/index.js";
var Header = function Header(_ref) {
  var avatarUrl = _ref.avatarUrl,
    studentName = _ref.studentName,
    description = _ref.description,
    metadata = _ref.metadata;
  return /*#__PURE__*/React.createElement(Flex, {
    gap: "small",
    alignItems: "start"
  }, /*#__PURE__*/React.createElement(Flex.Item, {
    width: "60px"
  }, /*#__PURE__*/React.createElement(Avatar, {
    as: "div",
    size: "large",
    name: studentName,
    src: avatarUrl,
    "data-testid": "lmgb-student-popover-avatar"
  })), /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(View, {
    display: "block",
    padding: "0 large 0 0",
    maxWidth: "320px"
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    size: "content",
    weight: "bold"
  }, /*#__PURE__*/React.createElement(TruncateText, null, studentName))), description && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    size: "contentSmall"
  }, /*#__PURE__*/React.createElement(TruncateText, null, description))), metadata && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    size: "legend"
  }, /*#__PURE__*/React.createElement(TruncateText, null, metadata))))));
};
var MasteryScores = function MasteryScores(_ref2) {
  var _masteryLevelConfig$m, _masteryLevelConfig$m2;
  var masteryScores = _ref2.masteryScores;
  var _useGradebookConfig = useGradebookConfig(),
    masteryLevelConfig = _useGradebookConfig.masteryLevelConfig;
  if (!masteryScores) return null;
  var averageIcon = masteryScores.averageIcon,
    averageText = masteryScores.averageText,
    grossAverage = masteryScores.grossAverage;
  var masteryLevelName = (masteryLevelConfig === null || masteryLevelConfig === void 0 ? void 0 : (_masteryLevelConfig$m = masteryLevelConfig.masteryLevelOverrides) === null || _masteryLevelConfig$m === void 0 ? void 0 : (_masteryLevelConfig$m2 = _masteryLevelConfig$m[averageIcon]) === null || _masteryLevelConfig$m2 === void 0 ? void 0 : _masteryLevelConfig$m2.name) || averageText;
  var availableBuckets = masteryLevelConfig === null || masteryLevelConfig === void 0 ? void 0 : masteryLevelConfig.availableLevels;
  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Flex.Item, {
    width: "60px"
  }), /*#__PURE__*/React.createElement(Flex.Item, {
    padding: "0 0 0 small"
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    alignItems: "center",
    gap: "small"
  }, /*#__PURE__*/React.createElement(Flex.Item, {
    width: "1.7rem"
  }, /*#__PURE__*/React.createElement(MasteryLevelIcon, {
    masteryLevel: averageIcon,
    ariaHidden: true
  })), /*#__PURE__*/React.createElement(Flex.Item, {
    padding: "0 0 xxx-small 0"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium"
  }, "".concat(grossAverage ? grossAverage.toFixed(1) + ' ' : '').concat(masteryLevelName)))), /*#__PURE__*/React.createElement(Flex, {
    gap: "small",
    margin: "x-small small small none"
  }, masteryScores.buckets && Object.values(masteryScores.buckets).filter(function (bucket) {
    return !availableBuckets || availableBuckets.includes(bucket.icon);
  }).reverse().map(function (bucket) {
    var _masteryLevelConfig$m3, _masteryLevelConfig$m4;
    var icon = bucket.icon,
      name = bucket.name,
      count = bucket.count;
    var bucketName = (masteryLevelConfig === null || masteryLevelConfig === void 0 ? void 0 : (_masteryLevelConfig$m3 = masteryLevelConfig.masteryLevelOverrides) === null || _masteryLevelConfig$m3 === void 0 ? void 0 : (_masteryLevelConfig$m4 = _masteryLevelConfig$m3[icon]) === null || _masteryLevelConfig$m4 === void 0 ? void 0 : _masteryLevelConfig$m4.name) || name;
    return /*#__PURE__*/React.createElement(Flex, {
      key: bucket.name,
      direction: "row",
      alignItems: "center",
      gap: "xx-small"
    }, /*#__PURE__*/React.createElement(Flex.Item, {
      width: "1.4rem",
      padding: "xxx-small 0 0 0"
    }, /*#__PURE__*/React.createElement(MasteryLevelIcon, {
      masteryLevel: icon,
      width: "100%",
      height: "100%",
      ariaHidden: true
    })), /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(ScreenReaderContent, null, "".concat(bucketName, " ").concat(count)), /*#__PURE__*/React.createElement(Text, {
      size: "medium",
      "aria-hidden": "true"
    }, bucket.count)));
  }))));
};
var Actions = function Actions(_ref3) {
  var studentGradesUrl = _ref3.studentGradesUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMessageModalOpen = _useState2[0],
    setIsMessageModalOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMessageModalOpen && /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    justifyItems: "center"
  }, /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(Link, {
    onClick: function onClick() {
      return setIsMessageModalOpen(true);
    },
    variant: "standalone"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, t('Message')))), /*#__PURE__*/React.createElement(View, {
    as: "div",
    margin: "none small none small",
    borderWidth: "none small none none",
    width: "0px",
    height: "1.4rem"
  }), studentGradesUrl && /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(Link, {
    href: studentGradesUrl,
    variant: "standalone"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, t('View Mastery Report'))))));
};
var Divider = function Divider() {
  return /*#__PURE__*/React.createElement(View, {
    as: "div",
    margin: "none none x-small none",
    borderWidth: "small none none none",
    height: "0px"
  });
};
var Loading = function Loading(_ref4) {
  var isLoading = _ref4.isLoading;
  if (!isLoading) return null;
  return /*#__PURE__*/React.createElement(View, {
    as: "div",
    textAlign: "center",
    margin: "medium none"
  }, /*#__PURE__*/React.createElement(Spinner, {
    renderTitle: t('Loading user details'),
    size: "small"
  }));
};
var ErrorMessage = function ErrorMessage(_ref5) {
  var error = _ref5.error;
  if (!error) return null;
  return /*#__PURE__*/React.createElement(View, {
    as: "div",
    margin: "large none"
  }, /*#__PURE__*/React.createElement(Text, null, error));
};
export var StudentPopover = function StudentPopover(_ref6) {
  var studentName = _ref6.studentName,
    avatarUrl = _ref6.avatarUrl,
    description = _ref6.description,
    metadata = _ref6.metadata,
    masteryScores = _ref6.masteryScores,
    headerOverride = _ref6.headerOverride,
    masteryScoresOverride = _ref6.masteryScoresOverride,
    actionsOverride = _ref6.actionsOverride,
    studentGradesUrl = _ref6.studentGradesUrl,
    _ref6$isLoading = _ref6.isLoading,
    isLoading = _ref6$isLoading === void 0 ? false : _ref6$isLoading,
    _ref6$error = _ref6.error,
    error = _ref6$error === void 0 ? null : _ref6$error,
    onShowingContentChange = _ref6.onShowingContentChange;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isShowingContent = _useState4[0],
    setIsShowingContent = _useState4[1];
  var handleShowingContentChange = function handleShowingContentChange(isShowing) {
    setIsShowingContent(isShowing);
    onShowingContentChange === null || onShowingContentChange === void 0 ? void 0 : onShowingContentChange(isShowing);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popover, {
    renderTrigger: /*#__PURE__*/React.createElement(Link, {
      isWithinText: false,
      "data-testid": "student-cell-link",
      "aria-haspopup": "dialog"
    }, /*#__PURE__*/React.createElement(TruncateText, null, studentName)),
    isShowingContent: isShowingContent,
    onShowContent: function onShowContent() {
      return handleShowingContentChange(true);
    },
    onHideContent: function onHideContent() {
      return handleShowingContentChange(false);
    },
    on: "click",
    screenReaderLabel: "".concat(t('Student Details for'), " ").concat(studentName),
    shouldContainFocus: true,
    shouldReturnFocus: true,
    shouldCloseOnDocumentClick: true,
    offsetY: "16px"
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(CloseButton, {
    placement: "end",
    offset: "small",
    onClick: function onClick() {
      return handleShowingContentChange(false);
    },
    screenReaderLabel: t('Close')
  })), /*#__PURE__*/React.createElement(Flex.Item, null, /*#__PURE__*/React.createElement(View, {
    padding: "small",
    margin: "xx-small 0 0 0",
    display: "block",
    maxWidth: "480px",
    minWidth: "300px",
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(Loading, {
    isLoading: isLoading
  }), /*#__PURE__*/React.createElement(ErrorMessage, {
    error: error
  }), !isLoading && !error && /*#__PURE__*/React.createElement(View, {
    as: "div"
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    alignItems: "start"
  }, /*#__PURE__*/React.createElement(Flex.Item, null, headerOverride !== null && headerOverride !== void 0 ? headerOverride : /*#__PURE__*/React.createElement(Header, {
    avatarUrl: avatarUrl,
    studentName: studentName,
    description: description,
    metadata: metadata
  })), /*#__PURE__*/React.createElement(Flex.Item, null, masteryScoresOverride !== null && masteryScoresOverride !== void 0 ? masteryScoresOverride : /*#__PURE__*/React.createElement(MasteryScores, {
    masteryScores: masteryScores
  }))), /*#__PURE__*/React.createElement(Divider, null), actionsOverride !== null && actionsOverride !== void 0 ? actionsOverride : /*#__PURE__*/React.createElement(Actions, {
    studentGradesUrl: studentGradesUrl
  })))))));
};